import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GridStatePersistingService } from '@core/services/grid-state-persisting/grid-state-persisting.service';
import { NgIdleService } from '@core/services/user-idle-manager/ng-idle.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars, faBook, faCaretDown, faCaretUp, faCheck, faCog, faEdit, faExclamationTriangle,
  faFilter, faLanguage, faLightbulb, faPaintBrush, faPen, faPlayCircle, faPlus, faPowerOff, faRocket, faSquare, faStream, faSync, faTasks, faTimes, faTrash, faUserCircle, faUserPlus, faWindowMaximize
} from '@fortawesome/free-solid-svg-icons';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { EditorModule } from "@progress/kendo-angular-editor";
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxPrintModule } from 'ngx-print';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MaterialModule } from '../material.module';
import { ClientTitleComponent } from './components/client-title/client-title.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { CustomizedEditorComponent } from './components/customized-editor/customized-editor.component';
import { MultiCheckFilterComponent } from './components/customized-grid/customized-filter/multicheck-filter.component';
import { CustomizedGridComponent } from './components/customized-grid/customized-grid.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { ErrorCodeComponent } from './components/error-code/error-code.component';
import { MiniProgressComponent } from './components/mini-progress/mini-progress.component';
import { MonthDayPickerComponent } from './components/month-day-picker/month-day-picker.component';
import { MonthDayYearPickerComponent } from './components/month-day-year-picker/month-day-year-picker.component';
import { MonthYearPickerComponent } from './components/month-year-picker/month-year-picker.component';
import { MultiSelectSearchComponent } from './components/multi-select-search/multi-select-search.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { SessionDialogComponent } from './components/session-dialog/session-dialog.component';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import { SortPipe } from './pipes/sort.pipe';

library.add(
  faBars,
  faUserCircle,
  faPowerOff,
  faCog,
  faRocket,
  faPlayCircle,
  faPlus,
  faEdit,
  faTrash,
  faTimes,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
  faFilter,
  faTasks,
  faCheck,
  faSquare,
  faLanguage,
  faPaintBrush,
  faLightbulb,
  faWindowMaximize,
  faStream,
  faBook,
  faPen,
  faUserPlus,
  faSync
);
const THIRD_MODULES = [
  DropDownsModule,
  EditorModule,
  ExcelModule,
  FlexLayoutModule,
  FontAwesomeModule,
  FormlyMaterialModule,
  FormlyModule,
  GridModule,
  LoadingBarModule,
  MaterialModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgSelectModule,
  NgxDatatableModule,
  NgxMatDatetimePickerModule,
  NgxMaterialTimepickerModule,
  NgxMatMomentModule,
  NgxMatTimepickerModule,
  NgxPrintModule,
  NgxSpinnerModule,
  TreeViewModule
];
const COMPONENTS = [
  ClientTitleComponent,
  CustomizedEditorComponent,
  CustomizedGridComponent,
  DateTimePickerComponent,
  ErrorCodeComponent,
  MiniProgressComponent,
  MonthDayPickerComponent,
  MonthDayYearPickerComponent,
  MonthYearPickerComponent,
  MultiCheckFilterComponent,
  MultiSelectSearchComponent,
  PageTitleComponent,
  YearPickerComponent
];
const COMPONENTS_DYNAMIC = [ConfirmDialogComponent, SessionDialogComponent];
const DIRECTIVES = [];
const SERVICES = [GridStatePersistingService, NgIdleService];
const PIPES_CUSTOMIZED = [SortPipe];
const PIPES = [DatePipe];

@NgModule({
  declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES_CUSTOMIZED, ...COMPONENTS_DYNAMIC],
  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, ...THIRD_MODULES],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ...THIRD_MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES_CUSTOMIZED,
    ...PIPES,
  ],
  providers: [PIPES, PIPES_CUSTOMIZED, ...SERVICES]
})
export class SharedModule { }
